var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 51,
    viewBox: "0 0 44 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "qfkw1zbvya",
    d: "M21.98.129C9.84.129 0 10.249 0 22.731c0 12.483 9.84 22.602 21.98 22.602 1.82 0 3.587-.228 5.279-.656 4.42 5.635 14.494 6.238 14.494 6.238s-6.929-4.932-5.951-10.61c4.976-4.143 8.158-10.476 8.158-17.574C43.96 10.248 34.12.129 21.98.129z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-745 -709) translate(95 157) translate(406 552) translate(88) translate(156)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j0hakhpmrb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qfkw1zbvya"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3B5998",
    d: "M21.98.129C9.84.129 0 10.249 0 22.731c0 12.483 9.84 22.602 21.98 22.602 1.82 0 3.587-.228 5.279-.656 4.42 5.635 14.494 6.238 14.494 6.238s-6.929-4.932-5.951-10.61c4.976-4.143 8.158-10.476 8.158-17.574C43.96 10.248 34.12.129 21.98.129z",
    mask: "url(#j0hakhpmrb)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.831.005L9.633 0C6.04 0 3.718 2.318 3.718 5.906V8.63H.503c-.278 0-.503.219-.503.49v3.945c0 .27.225.49.503.49h3.215v9.956c0 .27.225.489.503.489h4.196c.277 0 .502-.22.502-.49v-9.956h3.76c.278 0 .503-.219.503-.489l.002-3.946c0-.13-.054-.254-.148-.346-.094-.092-.222-.143-.356-.143H8.92V6.32c0-1.11.271-1.673 1.756-1.673h2.155c.277 0 .502-.22.502-.49V.494c0-.27-.224-.489-.502-.489z",
    transform: "translate(-745 -709) translate(95 157) translate(406 552) translate(88) translate(156) translate(15 11)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9507c3b79287da711dd496b6f60b9620.svg";
export { ForwardRef as ReactComponent };